const WORDS = ["Compassion", "Dignity", "Respect", "Patience", "Trust", "Warmth"];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-display italic font-light text-2xl md:text-3xl text-white px-8 md:px-12">
            {w}
          </span>
          <span aria-hidden className="w-1.5 h-1.5 rounded-full bg-silver/50" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-navy-dark border-y border-white/10 py-6 overflow-hidden select-none"
    >
      <div className="flex w-max animate-kch-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
